
import station from '@/modules/site'
import LayoutMixin from '@/mixins/layout'
import { mapState } from 'vuex'

export default {
  mixins: [LayoutMixin],
  async asyncData({ app, route }) {
    let result = {}
    const {
      params: { site },
    } = route
    try {
      const res = await app.$API.support.getSupportContent({ type: 7 }) // 7表示联系我们
      if (res && res.length > 0) {
        result = res[0] || {}
      }
    } catch (e) {
      result = {}
    }
    return {
      site,
      result,
    }
  },
  computed: {
    ...mapState({
      locale: (state) => state.locale,
      // site: (state) => state.site,
    }),
    // lang() {
    //   return this.locale.split('-')[0]?.toUpperCase() || ''
    // },
    comp() {
      return station[this.site]?.contact
    },
  },
  mounted(){
    if( this.site == 'gb' ){
       if( this.locale == 'zh-CN' ){
         // 中文
         window.open('https://kefu.sf.global/webim/im.html?configId=1fd82e7f-c0a2-4bb7-905d-3ec7a7016f90', '_blank')
       } else if( this.locale == 'en-US' ){
         // 英文
        window.open('https://kefu.sf.global/webim/im.html?configId=01bcfb07-f2a0-4d5b-8b8f-9b2c61b1fdcd', '_blank')
       }
    }
  },
  
}
